import {toRaw} from "vue";

const localStorageItemName = 'cachedState'

function createLocalStoragePlugin(modules) {
  const localStorage = window.localStorage

  return store => {
    const cachedData = JSON.parse(localStorage.getItem(localStorageItemName)) || {}
    store.commit('warmUpCache', cachedData)

    store.subscribe((mutation, state) => {

      const changedState = toRaw(state)
      const moduleName = mutation.type.split('/')[0]

      if (modules.includes(moduleName)) {

        const cachedData = JSON.parse(localStorage.getItem(localStorageItemName)) || {}
        cachedData[moduleName] = changedState[moduleName]
        localStorage.setItem(localStorageItemName, JSON.stringify(cachedData))
      }
    })
  }
}

export default createLocalStoragePlugin
